const nicknamePattern = /^[\p{L}\p{N} ._'-]*$/u;

export function normalizeNickname(value: string): string {
  const normalized = value.trim().replace(/\s+/g, ' ').slice(0, 40);
  if (!normalized || !nicknamePattern.test(normalized)) {
    return 'Anonymous';
  }
  return normalized;
}

export function validateComment(value: string): string | null {
  const normalized = value.trim();
  if (!normalized) return 'Write a comment before posting.';
  if (normalized.length > 500) return 'Comments are limited to 500 characters.';
  if (
    [...normalized].some((character) => {
      const codePoint = character.codePointAt(0) ?? 0;
      return (codePoint < 32 && codePoint !== 9 && codePoint !== 10 && codePoint !== 13) ||
        codePoint === 127;
    })
  ) {
    return 'Remove unsupported control characters.';
  }
  return null;
}
